import styled from "styled-components";

export const ContainerSelectFamiliar = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .title {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
    margin-top: 40px;
    margin-bottom: 30px;
  }
`;

export const ButtonOne = styled.button`
  width: 303px;
  height: 76px;
  background: var(--color-secondary-gradient);
  border-radius: 18px;
  color: var(--color-white);
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 12px;
  padding-left: 30px;
  font-weight: 700;
  font-size: 20px;
  line-height: 150%;
`;

export const ButtonTwo = styled.button`
  width: 303px;
  height: 48px;
  min-height: 48px;
  background: var(--color-secondary-gradient);
  border-radius: 8px;
  color: var(--color-white);
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  display: flex;
  justify-content: start;
  align-items: center;
  padding-left: 45px;
  .circle {
    color: var(--color-white);
    font-weight: 400;
    font-size: 30px;
    line-height: 150%;
    margin-right: 10px;
  }
`;

export const ContainerAdd = styled.div`
  width: 100%;
  margin-top: 50px;
  height: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  .circle {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: var(--color-primary);
    color: var(--color-white);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 40px;
    line-height: 150%;
  }
  .subtitle {
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
  }
  @media (max-height: 700px) {
    margin-top: 10px;

  }
`;


export const ContainerButtons = styled.div`
  width: 98%;
  height: calc(100vh - 450px);
  height: calc(100dvh - 450px);
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-x: scroll;
  gap: 20px;

  ::-webkit-scrollbar {
    width: 10px;
    /* height: 100px; */
  }

  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: var(--color-scrollbar);
    height: 100px;
  }
 
`;